const digest = '33f9843cb1c101209d0fee5794ecb48a06abf090951d79ebd75267e89dd8ebd1';
const css = `._locationsBox_2dods_1{width:calc(50% - 2.125rem)}._swapButtonWrapper_2dods_5{align-self:flex-end;height:3.125rem;padding:0 .563rem;width:4.25rem}._swapButtonWrapper_2dods_5 ._swapButton_2dods_5{height:100%;min-width:1rem;width:100%}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'locationsBox': '_locationsBox_2dods_1', 'swapButtonWrapper': '_swapButtonWrapper_2dods_5', 'swapButton': '_swapButton_2dods_5' };
export const locationsBox = '_locationsBox_2dods_1';
export const swapButtonWrapper = '_swapButtonWrapper_2dods_5';
export const swapButton = '_swapButton_2dods_5';
export { css, digest };